import { refererLogin } from "../api/api";
import { GetQueryString } from "./utils";

export const referer = async (store, router, app_id) => {
  let ak = GetQueryString("ak");
  let referer = GetQueryString("referer") || document.referrer;
  let data = { referer, ak, appid: app_id };
  if (referer && ak) {
    return refererLogin(data).then(res => {
      let token = res.data.token;
      sessionStorage.setItem("login-res", JSON.stringify(res.data));
      sessionStorage.setItem("userName", res.data.username);
      sessionStorage.setItem("REFREASH_TOKEN_KEY", res.data.refresh_token);
      return sessionStorage.setItem(`token_${app_id}`, token);
    });
  }
};

export const hideHeaderOrLeftMenu = store => {
  let hideHeader = GetQueryString("hideHeader");
  let hideLeftMenu = GetQueryString("hideLeftMenu");
  // 根据参数控制头部和侧边菜单栏显示隐藏
  hideHeader && store.commit("updateHideHeader", true);
  hideLeftMenu && store.commit("updateHideLeftMenu", true);
};
